export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: '100%',
  height: isMobile ? '100%' : 'auto',
  maxWidth: isMobile ? 'none' : '450px',
  padding: isMobile ? '1.25rem 0.375rem 1.375rem' : '1.5rem 0.5625rem 1.375rem',
});
